import { useEffect, useState } from 'react';
import services from '../../../services';
import { useSelector } from 'react-redux';
import { selectSelectedCountryCode, selectSelectedCurrency } from '../../../store/user';
import { Helmet } from 'react-helmet-new';
import SeoData from '../../../utils/seo.json';
import aboutMatwImg from '../../../images/others/about-matw.png';
import AppealImpact from '../../MATWAppeal/components/appealImpact';
import { CustomButton } from '../../../components/general';
import { useRef } from 'react';
import NewHelmetLayout from '../../../components/general/newHelmetLayout';
import { getCreatorCodesWithDates } from '../../MATWAppeal/dates';
import { calculateCampaigns } from '../../MATWAppeal/campaignCalculation';
import AppealWidget from '../../MATWAppeal/components/appealWidget';
import { selectProducts } from '../../../store/products';

const AllAppeals = () => {
  const selectedCurrency = useSelector(selectSelectedCurrency);
  const selectedcountryCode = useSelector(selectSelectedCountryCode);
  const seo = SeoData[selectedcountryCode];
  const appealsRef = useRef(null);
  const [appealProducts, setAppealProducts] = useState([0, 0]);
  const [allOrders, setAllOrders] = useState([]);
  const allProducts = useSelector(state => selectProducts(state));
  /* ------------------------------ Start methods ----------------------------- */
  const getLatestOrdersVersion3 = async () => {
    let req = {
      products: getCreatorCodesWithDates(),
      currency: selectedCurrency
    };
    try {
      const response = await services.getLatestOrdersV3(req);
      setAllOrders(response.data);
    } catch (error) {
      console.error('error========', error);
    }
  };
  /* -------------------------------------------------------------------------- */
  /* ------------------------------- Start hooks ------------------------------ */
  useEffect(() => {
    if (allOrders && allProducts && Object.keys(allProducts).length) {
      const { appealProducts } = calculateCampaigns({
        allProducts,
        _prds: allOrders,
        selectedCurrency,
        campaign: 'palestine'
      });
      setAppealProducts(appealProducts);
    }
  }, [allOrders, allProducts]);
  useEffect(() => {
    selectedCurrency && getLatestOrdersVersion3();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCurrency]);
  /* -------------------------------------------------------------------------- */

  return (
    <NewHelmetLayout className="!bg-white">
      {seo && (
        <Helmet>
          <title>{`${seo['appeals']['title']}`}</title>
          <link rel="canonical" href={`${window.location.protocol}//${window.location.host.replace(/^www\./i, "")}${window.location.pathname}`} />
          <meta name="description" content={`${seo['appeals']['description']}`} />

          <link rel="alternate" href={`https://matwproject.org.uk${window.location.pathname}`} hreflang="en-gb" />
          <link rel="alternate" href={`https://matwproject.org${window.location.pathname}`} hreflang="x-default" />
          <link rel="alternate" href={`https://matwprojectca.org${window.location.pathname}`} hreflang="en-ca" />
          <link rel="alternate" href={`https://matwproject.org/fr${window.location.pathname}`} hreflang="fr-fr" />
          <link rel="alternate" href={`https://matwprojectusa.org${window.location.pathname}`} hreflang="en-us" />
          <link rel="alternate" href={`https://matwprojectid.org${window.location.pathname}`} hreflang="en-id" />
          <link rel="alternate" href={`https://matwprojectmys.org${window.location.pathname}`} hreflang="en-my" />
          <link rel="alternate" href={`https://matwprojectsgp.org${window.location.pathname}`} hreflang="en-sg" />
        </Helmet>
      )}
      <div id="other_appeals">
        <AppealWidget allProducts={appealProducts} title={'MATW Appeals'} />
      </div>
      <div className="py-[30px] lg:py-[50px]">
        <AppealImpact usedOnTab buttonClassname="bg-[rgb(0,163,218)]" />
      </div>
      <section className="max-w-[1280px] w-full mx-auto px-5 lg:px-6">
        <h2 className="text-center text-[30px] lg:text-[40px] leading-[32px] lg:leading-[42px] font-bold text-DarkerBlue font-brandingBold mb-[30px] lg:mb-[50px]">
          About MATW Appeals
        </h2>
        <div className="grid lg:grid-cols-2 gap-y-8  gap-x-8 items-center">
          <img src={aboutMatwImg} alt="About Matw" className="w-full" />
          <div className="">
            <p className="text-[24px]   leading-normal font-brandingMedium text-[#78716C]">
              MATW Appeals is your gateway to making a lasting difference in the lives of those most in need. Each appeal represents a direct
              opportunity to provide essential relief such as food, water, shelter, and medical care to families facing unimaginable hardship. Whether
              it’s helping orphans, building water wells, or supporting emergency relief efforts, your contribution through MATW Appeals goes directly
              towards rebuilding lives and restoring dignity. <br /> Join us in delivering hope, rebuilding communities, and offering a future to
              those who need it most. Together, we can create meaningful change.
            </p>
            <CustomButton
              onClicked={() => {
                appealsRef.current.scrollIntoView({ behavior: 'smooth' });
              }}
              title="Donate Now"
              className="!w-fit !mt-5 lg:!mt-[30px]"
            />
          </div>
        </div>
      </section>
    </NewHelmetLayout>
  );
};

export default AllAppeals;
